import { render } from "./DraggableListDemo.vue?vue&type=template&id=3a8cddfe"
import script from "./DraggableListDemo.vue?vue&type=script&lang=ts"
export * from "./DraggableListDemo.vue?vue&type=script&lang=ts"
script.render = render

export default script